import OtherWaste from '../components/OtherWaste';

function OtherWastePage() {
  return <OtherWaste />;
}

export default OtherWastePage;
